"use client";

import { ChangeEvent } from "react";

interface IVerificationInputField {
  id: string;
  name: string;
  value?: string;
  disabled?: boolean;
  defaultValue?: string;
  handleOnChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export default function VerificationInputField({
  id,
  name,
  value,
  defaultValue,
  disabled,
  handleOnChange,
}: IVerificationInputField) {
  return (
    <input
      type="text"
      maxLength={1}
      id={id}
      name={name}
      placeholder="0"
      value={value}
      defaultValue={defaultValue}
      onChange={handleOnChange}
      disabled={disabled}
      className="w-[2.25rem] md:w-[2.938rem] h-[3.125rem] md:h-[3.625rem] text-center text-base md:text-xl font-medium bg-white rounded-full border border-agenda-grey-200 focus:border-agenda-blue-600 outline-none text-agenda-purple-800 py-2 px-2 leading-8 transition-colors duration-200 ease-in-out"
    />
  );
}
